var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeedHelpIllustrationRunningHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 521.47,
    height: 299,
    viewBox: "0 0 521.47 299",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "u4vo77chca",
    d: "M0 0h85.222v37.079H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w25orj8r0c",
    d: "M.32.325h.641v.65h-.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "hxb7aoxove"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "ikxidcvp4g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "vasmwdaevi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "pdmzexsgyk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "k3tnc4oblm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "gaowtsstpo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "7fz7jfifsq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "g19vrb88zs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "qg25c0lvdu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "rnkzhqxl3w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "cojr5lw1ny"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "jy7nvoyj6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "8dqslaxjmC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "0x4fykxs6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "gsdpdzmqnG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "ojte4frjnI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "kcatul8xiK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "3q2xd38ojM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "falqm55m6O"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "879shvwu3Q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "j9hlpl370S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "6myfb9kgrU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "ptuuimg3xW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "ybj0bgl51Y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "he4wooeiwaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "yo9o87jeeac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "t7bhxl3tmae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "2p6o5zuksag"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "siwr165n5ai"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "hpgnbk4irak"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "4zcdhz8otam"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "ucz5wenpaao"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "pysaw6d7haq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "txest7c7uas"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "womu3f01mau"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "cnnwxmle1aw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "x16wynk34ay"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "qx7cl80g5aA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "5y6kp1o62aC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "omfm3u9dvaE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "rj7tykfgsaG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "8sg17v57maI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "2de0n95ajaK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "p6o9apjz0aM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "cmre7nutfaO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "ddzozvyhtaQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "wmzdqhxkhaS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "dp0w24lw8aU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "aovq7pwiwaW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "36xkd858uaY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "ijlzujavgba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "vloc7rzozbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "8taz5skupbe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "zjql5rjw6bg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "xh8qyewgqbi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "ptho07ppxbk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "1c17suzmlbm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "rh9tibwcabo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "ez605nafqbq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "9bt1k88jfbs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "l2afi18vbbu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "rgv3odzajbw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "em3f91z5pby"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "m6les01nobA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "2kcs2wzxkbC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "qaifzp37tbE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "tdaz218hjbG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "6oly68inqbI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "6zxubtgvrbK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "7hdlzahwcbM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "eo2j1nnhcbO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "z5c3wce9cbQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "j4axjw5qmbS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "0iifytzenbU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "rb4cib511bW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "x6xkezpa8bY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "iz89xarmvca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "z7ijzqnngcc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "b6b9dw53gce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "w6c1vk8fccg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "90uzz361uci"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "tq8qgrbkqck"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "0hqsgnqumcm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "xjdp5hctxco"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "qxb9uzl6hcq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "i3a62vhh4cs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "2qn5bma8zcu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "ctyy3kie0cw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "qhaq1a0qhcy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "59vc53cfkcA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "t32acz0djcC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "xpn8apgd1cE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "3ya7trtytcG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "ftpc6cqencI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "q30ag5e4qcK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "84sejyhvrcM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "gn6lawix5cO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "6p747arv0cQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "qorf10wz3cS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "32hy2axrycU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "x53yq1g4vcW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 48.853 162.22 122.004 9.527-8.527S28.374 3.034 23.301 0",
    id: "kxn3gvdrlcY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "w026elukyda"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "ejfeq1nijdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "d68yr93thde"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "xqslqn9x7dg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "7uihid7zxdi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "ixgiqm167dk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "plc4xl7b2dm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "59n07vh0ado"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "133y0sgx6dq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "w44omzt2wds"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "v82wyt4twdu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "8sqe5vakqdw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "2dyrwrhg3dy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "izamvbpgwdA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "t93b8mnj0dC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "oaaopso2jdE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "r1rolrj38dG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "uhygbjjuudI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "1areedvkfdK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "t4djerchzdM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "8meotnw84dO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "ccvshipusdQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "pyjefexixdS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "sj01ievz2dU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "kbs89fomwdW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "t45f7v12vdY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "jygrz1gbnea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "z5pqp7csgec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "066ett8yaee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "0w8anyq73eg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "v3s6ud036ei"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "5hf8s7jk3ek"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "61z6b2uirem"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "qtevkk77qeo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "i3iz9jog4eq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "szsrffak4es"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "w5debtwkheu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "mto3okapzew"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "ti72tcrgsey"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "2q3rqwk69eA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "tvmko32aheC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "7dwpryxkpeE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "x7oi6lm7veG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "z8ktz7r0ieI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "lyf9uvg63eK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "stkzr5ztbeM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "kun8gv4xweO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "gxfwddmskeQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "vmo936yhxeS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "tz54hunyfeU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "xhjcj98dreW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "gbfc2i3q0eY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "lhj60m170fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "ic8vvyiuufc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "znq3vyb62fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "1qv0rvpmpfg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "47y4h86qffi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "vi3pbgczhfk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "lmsvytglvfm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "j6ozycfa6fo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "84tp3uboifq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "jd2kdtlgyfs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "a6ahu6gvpfu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "2jsluad4cfw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "qzy0yjx7mfy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "jwgg0bkiqfA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "hu6r8d961fC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "8yu14ekzpfE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "hd1sozn4qfG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "k7eblghl0fI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "iqb3fm7bhfK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "ou3xir22cfM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "sxu209nxwfO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "o73zl89wmfQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "uyxs3zakvfS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "05jv8khjlfU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "yan2xso7zfW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "esipc0b9cfY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "uya51mt2lga"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "kj4bydtsrgc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "kkmfwru4cge"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "qttsgrtlsgg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "8dvny28nwgi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "ioza8613fgk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "85lvlezf7gm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "8a52xhb09go"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "8yhp7v2o9gq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "3mamav0i7gs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "ubx2vj2chgu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "6qt81vuzggw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "nexwqcj0agy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "2sean35gxgA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "ifxxvoj15gC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "d0tiuleb5gE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "6jbab29wggG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "uk88wkuycgI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "0xy3eaa5qgK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "o83tfbf42gM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.962 88.192a4.817 4.817 0 0 1-4.123 2.34L.995 90.446 0 105.504s87.006 16.704 107.543 12.022c0 0 32.525-10 73.103-107.148L132.834 0",
    id: "lvs630z7cgO"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lsvb958ywgQ",
    d: "M0 0h85.222v37.079H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m323.97 122.085 20.542 5.259c3.911 2.808 7.574 4.827 10.986 6.055.983.143 2.592-.036.475-2.26-2.117-2.226-4.246-4.66-3.71-5.656.534-.997 2.664-.358 3.204-1.922.362-1.041-3.148-1.621-10.527-1.74l-16.17-8.683-4.8 8.947zM246.799 99.713a3.563 3.563 0 0 0-4.029 2.215c-.723 1.855.178 3.95 2.012 4.68a3.564 3.564 0 0 0 4.63-2.034c.724-1.854-.18-3.95-2.013-4.681a3.761 3.761 0 0 0-.6-.18M243.428 120.672a3.564 3.564 0 0 0-4.029 2.215c-.723 1.855.178 3.95 2.014 4.681.198.079.398.138.599.18a3.565 3.565 0 0 0 4.03-2.216c.722-1.853-.18-3.95-2.014-4.679a3.675 3.675 0 0 0-.6-.18M236.735 140.31a3.562 3.562 0 0 0-4.028 2.214c-.723 1.855.178 3.95 2.012 4.68.198.078.399.14.6.18a3.566 3.566 0 0 0 4.03-2.215c.722-1.854-.18-3.95-2.013-4.68a3.438 3.438 0 0 0-.6-.18M280.594 14.248c0 1.84-1.05 3.332-2.344 3.332-1.294 0-2.343-1.492-2.343-3.332 0-1.84 1.05-3.331 2.343-3.331 1.295 0 2.344 1.492 2.344 3.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.222 122.085 20.542 5.259c3.911 2.808 7.573 4.827 10.986 6.055.984.143 2.592-.036.475-2.26-2.117-2.226-4.246-4.66-3.71-5.656.534-.997 2.664-.358 3.204-1.922.362-1.041-3.148-1.621-10.527-1.74l-16.17-8.683-4.8 8.947zM362.122 109.257c7.375 3.476 14.126 4.622 15.075 2.56.952-2.062-4.254-6.552-11.63-10.029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.841 105.549c3.671-.103 7.625.684 11.829 2.326 2.07.809 3.098 3.158 2.3 5.25a4.024 4.024 0 0 1-2.589 2.423c.791.64 1.59 1.275 2.394 1.907l-7.814 14.49c-29.534-16.55-57.415-29.276-69.26-54.97-3.976-8.623-1.27-37.2-1.235-47.639l9.707-3.532c12.092 28.362 28.93 55.804 54.668 79.745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.547 19.978c-1.424-3.535-1.888-7.433-.375-11.113 4.36-10.603 18.655-3.104 19.773 3.372 1.118 6.475-3.84 20.26-7.956 19.956-1.643-.123-4.547-2.172-7.17-5.262l-2.778 15.288-12.154-4.116 10.66-18.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.825 111.443c24.975 13.293 38.105 1.34 54.224 4.41 6.561-23.765 15.969-61.473 18.645-77.228-.504 2.973-3.196-6.513-8.996-9.872-26.134 18.053-44.75 43.293-63.873 82.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.045 33.629s2.44 6.706 7.31 6.978c0 0 4.296 10.894-10.914 62.644l-23.677-4.24 19.035-56.79 8.246-8.592zM219.095 117.076c-18.6 35.177-46.219 78.78-47.795 79.873-1.053.73-44.308.487-100.925-.723l-.887 9.787c63.82 12.294 112.62 16.566 117.559 12.812 7.409-5.63 44.986-55.881 66.613-88.2l-34.565-13.549z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.844 196.032c-1.733-.993-3.057-1.563-3.972-1.709-1.111-.178-2.766-.25-4.958-.218l-5.512 35.18c3.594.862 4.919-.193 5.466-2.124.548-1.932.642-2.218 1.038-3.489l9.773-15.197a.635.635 0 0 0-.183-.873l-.015-.01-2.358-1.454c-.555-1.958-.744-3.507-.565-4.649.144-.925.715-2.144 1.71-3.659a1.27 1.27 0 0 0-.348-1.75l-.076-.048zM80.53 194.75l-1.001 15.071s87.567 16.718 108.237 12.032c0 0 32.735-10.009 73.574-107.233l-48.12-10.386-41.136 88.262a4.856 4.856 0 0 1-4.15 2.341l-87.404-.086z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "m201.113 144.043 105.337 75.32 84.917 65.399 8.19-3.408-158.085-154.101z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.306 285.786c.079 1.826.286 3.13.618 3.913.405.95 1.156 2.272 2.25 3.962 1.108-.467 11.057-4.677 29.85-12.63-1.133-2.711-2.068-3.87-3.828-3.367a125.88 125.88 0 0 1-3.68 1.006l-16.498-.296a.574.574 0 0 0-.585.563v.015l.027 2.535c-1.24 1.374-2.344 2.265-3.313 2.674-.786.334-2.005.476-3.659.43a1.146 1.146 0 0 0-1.182 1.113v.082zM384.214 283.542l9.574-8.53s-144.085-159.35-149.182-162.385l-23.416 48.87 163.024 122.045zM168.115 88.17l8.202 5.062c-18.263 16.254-27.99 24.82-29.18 25.698-2.679 1.978-2.887 7.354-3.247 10.091-3.994-.516-.477-5.49-5.558-6.072-4.637-.53-9.247.826-11.84-4.287-.32-.628-.15-2.16 1.777-2.257 4.802-.246 12.161-1.314 13.638-2.243 2.014-1.268 10.75-9.932 26.208-25.992M285.267 31.066s-4.847 3.456-5.84 12.362c-1.313.017-2.352-4.678-2.352-4.678l3.018-9.35 3.072-2.74 2.102 4.406z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212.397)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ahjmfb81yb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u4vo77chca"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.662 15.953s4.692-4.639 13.308-2.484c0 0 3.948-4.438-2.175-8.199-6.123-3.762-10.65-4.89-18.52-.537-6.434 3.558-10.488 2.87-15.441.63-4.954-2.238-7.52-4.875-11.616-3.909-4.097.967-6.65 4.823-11.074 3.154C20.721 2.94 18.862-1.769 11.1.702 3.338 3.174-6.256 15.425 5.495 27.784c11.75 12.359 29.329 9.564 39.997 7.415s20.673-4.624 21.976-8.175c1.303-3.553-2.031-7.535 3.194-11.071",
    fill: "#FEFEFE",
    mask: "url(#ahjmfb81yb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.832 58.86c12.877-7.299 28.484-9.787 45.518-13.339l-10.994 6.56-27.176 9.032s-7.316-.337-7.348-2.252M283.947 17.262c0 1.827-1.055 3.308-2.358 3.308-1.303 0-2.359-1.48-2.359-3.308 0-1.826 1.056-3.306 2.359-3.306s2.358 1.48 2.358 3.306M296.336 22.663l.598 6.144a.597.597 0 0 1-.786.622l-3.416-1.158 3.604-5.608z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.705 94.92 3.692.417s-32.291 33.922-39.757 31.679c-7.466-2.244-38.26-37.826-35.94-45.602 2.317-7.775 34.453-24.316 34.453-24.316l37.552 37.822z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.94 115.866a4.016 4.016 0 0 1 .207-3.828l1.409-2.29a4.05 4.05 0 0 1 4.473-1.794 68.284 68.284 0 0 0 2.194-3.441c5.8-9.75 6.953-21.09 11.049-31.063-17.958 6.154-37.813 21.157-59.568 45.013l-13.957-10.83a307.827 307.827 0 0 1 4.484-5.875c-1.414-1.748-1.675-7.314.17-7.502a19.846 19.846 0 0 1 5.709.241c31.647-37.777 67.874-60.265 108.685-67.468l4.516 1.773 4.62 3.512c-17.377 35.796-23.887 106.213-67.514 165.912-11.918-1.862-20.812-11.422-34.197-18.757-16.93-9.278-23.574-30.083-45.857-29.976 12.231-27.2 52.05-8.457 73.576-33.627",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.934 102.1a3.596 3.596 0 0 0-4.055 2.2 3.576 3.576 0 0 0 2.026 4.644 3.597 3.597 0 0 0 4.66-2.02 3.58 3.58 0 0 0-2.63-4.824M233.056 121.675a3.597 3.597 0 0 0-4.056 2.199 3.578 3.578 0 0 0 2.63 4.824 3.598 3.598 0 0 0 4.057-2.198 3.578 3.578 0 0 0-2.027-4.646 3.738 3.738 0 0 0-.604-.179M225.496 142.398a3.595 3.595 0 0 0-4.055 2.2 3.576 3.576 0 0 0 2.026 4.644 3.6 3.6 0 0 0 4.66-2.02 3.578 3.578 0 0 0-2.026-4.644c-.2-.08-.402-.139-.605-.18M257.889 27.029s-4.325 26.207-18.803 42.995C225.61 85.653 201.468 94.37 201.468 94.37l4.14 3.638s18.72-3.355 40.062-28.56c15.685-18.523 18.098-42.53 18.098-42.53l-5.879.11zM397.084 289.12l6.009 3.87 15.151-6.667-2.734-5.12-18.426 7.918zm-1.07.46 1.07-.46-1.07.46zm-6.026 2.45 3.332 5.08 7.853-3.487-3.158-5.042-8.027 3.45zM296.39 23.125l-1.467-.821a2.44 2.44 0 0 1-.937-3.352l.959-1.663a.768.768 0 0 1 1.04-.283l2.97 1.664a.088.088 0 0 1 .034.12l-2.478 4.302a.09.09 0 0 1-.122.033",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeWidth: 0.903,
    strokeLinecap: "round",
    d: "m294.551 17.798-10.679-2.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M65.851 196.664 60.6 230.479l-5.427-1.373 2.512-19.016 6.58-3.21.185-1.202-6.038.038 1.275-8.881zM367.164 123.945s5.269 8.672-5.858 8.672l5.858-8.672zM363.609 105.251c1.843.68 3.53.695 3.768.034.237-.661-1.065-1.748-2.908-2.429-1.843-.68-3.53-.695-3.768-.034-.237.661 1.065 1.75 2.908 2.43"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 297.701)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qsecpg9j0d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w25orj8r0c"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M35.595 26.036v38.925l65.851-25.814L90.471 8.899zM171.082 40.935 151.28 76.243l51.39 30.543 19.8-35.309z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F2EE",
    d: "M105.488 17.798 70.301 42.925l50.431 28.265 29.658-24.546zM0 64.726l6.33 33.16 51.512-33.018-14.204-23.933z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m328.338 122.459 20.573 5.236c3.917 2.796 7.586 4.806 11.002 6.029.986.143 2.597-.036.476-2.25-2.12-2.216-4.252-4.64-3.716-5.632.535-.993 2.668-.356 3.21-1.913.362-1.037-3.153-1.614-10.543-1.733l-16.195-8.645-4.807 8.908zM251.048 100.185a3.573 3.573 0 0 0-4.035 2.205 3.596 3.596 0 0 0 2.618 4.84 3.573 3.573 0 0 0 4.035-2.206 3.6 3.6 0 0 0-2.618-4.84M247.672 121.053a3.574 3.574 0 0 0-4.035 2.205 3.598 3.598 0 0 0 2.617 4.84 3.574 3.574 0 0 0 4.036-2.206 3.599 3.599 0 0 0-2.618-4.84M240.97 140.604a3.571 3.571 0 0 0-4.035 2.206 3.596 3.596 0 0 0 2.616 4.839c1.668.34 3.39-.56 4.036-2.206a3.6 3.6 0 0 0-2.618-4.839M284.895 15.091c0 1.833-1.05 3.318-2.347 3.318-1.296 0-2.347-1.485-2.347-3.318 0-1.831 1.05-3.316 2.347-3.316 1.296 0 2.347 1.485 2.347 3.316",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.593 122.459 20.574 5.236c3.917 2.796 7.584 4.806 11.002 6.029.985.143 2.596-.036.476-2.25-2.12-2.216-4.252-4.64-3.716-5.632.535-.993 2.668-.356 3.21-1.913.361-1.037-3.154-1.614-10.544-1.733l-16.194-8.645-4.808 8.908z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.9 99.7c-.93 2.003-4.904 31.474-4.904 31.474s4.933 5.793 12.52 5.868l19.131-24.807L354.9 99.701z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.548 109.688c7.386 3.46 14.148 4.6 15.098 2.547.954-2.052-4.26-6.522-11.648-9.984-7.386-3.461-14.146-4.603-15.098-2.55-.953 2.053 4.262 6.526 11.648 9.987",
    fill: "#8D8785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.713 89.2c-.479-3.841-.901-8.556-4.058-11.236-1.763-1.5-7.16-3.107-7.511.614-.293 3.09 4.688 4.744 6.72 5.84 2.136 1.155 2.936 2.36 3.698 4.676.173.038.349.071.523.106",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.213 105.995c3.676-.103 7.637.682 11.847 2.316a4.049 4.049 0 0 1-.29 7.64c.793.637 1.592 1.27 2.399 1.898l-7.827 14.428c-29.58-16.479-57.503-29.15-69.366-54.73-3.982-8.587-1.272-37.04-1.236-47.433l9.72-3.517c12.111 28.239 28.975 55.561 54.753 79.398",
    fill: "#AAE2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.842 20.796c-1.427-3.52-1.891-7.4-.376-11.064 4.367-10.557 18.684-3.09 19.803 3.357 1.12 6.447-3.845 20.172-7.968 19.869-1.645-.122-4.554-2.162-7.181-5.24l-2.782 15.223-12.173-4.098 10.677-18.047z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.012 111.864c25.013 13.235 38.163 1.333 54.307 4.39 6.57-23.661 15.992-61.205 18.673-76.892-.505 2.96-3.201-6.484-9.01-9.829-26.174 17.975-44.818 43.105-63.97 82.33",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.331 34.388s2.443 6.676 7.321 6.948c0 0 4.303 10.846-10.93 62.372l-23.713-4.222 19.064-56.544 8.258-8.554z",
    fill: "#DFE15C"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FE912A",
    d: "m202.003 144.043 105.337 75.32 84.917 65.399 8.19-3.408-158.085-154.101z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M220.576 119.722c-18.684 34.907-46.425 78.174-48.01 79.26-1.057.724-44.505.483-101.375-.718l-.89 9.712c64.104 12.2 113.123 16.439 118.083 12.714 7.443-5.587 45.188-55.453 66.911-87.523l-34.719-13.445z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.664 283.872 9.553-8.527S250.44 116.049 245.354 113.015l-23.366 48.853 162.676 122.004z",
    fill: "#9C3A83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3p6m1se2hf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hxb7aoxove"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#3p6m1se2hf)",
    d: "m-14.073-26.583.153 9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hfu1p7zp4h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ikxidcvp4g"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#hfu1p7zp4h)",
    d: "m42.61 21.517.152 9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yeqn62vk6j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vasmwdaevi"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#yeqn62vk6j)",
    d: "m-13.303 29.209 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qupiv4jo6l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pdmzexsgyk"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#qupiv4jo6l)",
    d: "m43.379 77.309 9.402-1.676"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "shgo56vwpn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k3tnc4oblm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#shgo56vwpn)",
    d: "m-15.56 42.518-.153-9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e0krbp3ljp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gaowtsstpo"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#e0krbp3ljp)",
    d: "m-34.392 10.415.152 9.562"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yjwkz8cw9r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7fz7jfifsq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#yjwkz8cw9r)",
    d: "m22.29 58.515.153 9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nvsmmfv39t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g19vrb88zs"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#nvsmmfv39t)",
    d: "m65.224 107.753.152 9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e0sydnl9gv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qg25c0lvdu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#e0sydnl9gv)",
    d: "M19.083 2.173 28.485.498"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "llhhbku0dx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rnkzhqxl3w"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#llhhbku0dx)",
    d: "m75.766 50.273 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wy31rlbv6z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cojr5lw1ny"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#wy31rlbv6z)",
    d: "m1.676 49.629 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5olxqul2fB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jy7nvoyj6A"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#5olxqul2fB)",
    d: "m-24.497 6.218 4.616 8.372"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jfgtcn1avD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8dqslaxjmC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#jfgtcn1avD)",
    d: "m32.185 54.317 4.616 8.372"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sq1ycuxplF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0x4fykxs6E"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#sq1ycuxplF)",
    d: "m16.857 12.702 9.087 2.941"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s34jw0x2mH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gsdpdzmqnG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#s34jw0x2mH)",
    d: "m73.539 60.802 9.088 2.941"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4s02h669mJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ojte4frjnI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#4s02h669mJ)",
    d: "M-.551 60.158 8.537 63.1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "capl3p21vL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kcatul8xiK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#capl3p21vL)",
    d: "m-11.198-.046.152 9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m89m4ywuzN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3q2xd38ojM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#m89m4ywuzN)",
    d: "m45.484 48.053.152 9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pi2itp6yqP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#falqm55m6O"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#pi2itp6yqP)",
    d: "m13.256 26.971 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nbw6gn94jR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#879shvwu3Q"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#nbw6gn94jR)",
    d: "m69.938 75.071 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "q4aysas2lT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j9hlpl370S"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#q4aysas2lT)",
    d: "m61.308 35.297 9.401-1.676"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "04lu91kb9V",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6myfb9kgrU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#04lu91kb9V)",
    d: "m-11.401-6.008-8.091-5.08"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "stf5xaeb1X",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ptuuimg3xW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#stf5xaeb1X)",
    d: "m45.282 42.092-8.091-5.08"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pqgpcn3khZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ybj0bgl51Y"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#pqgpcn3khZ)",
    d: "m49.762 90.878-8.09-5.081"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fvzxnig8zab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#he4wooeiwaa"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#fvzxnig8zab)",
    d: "M7.374 27.91.85 20.926"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "smy4mka4iad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yo9o87jeeac"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#smy4mka4iad)",
    d: "m57.477 29.951-6.524-6.984"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c7p0kuo6taf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t7bhxl3tmae"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#c7p0kuo6taf)",
    d: "m64.056 76.009-6.524-6.984"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "066qp4fmkah",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2p6o5zuksag"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#066qp4fmkah)",
    d: "m-32.716 2.65-8.091-5.081"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5vtae29vzaj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#siwr165n5ai"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#5vtae29vzaj)",
    d: "m23.967 50.75-8.091-5.081"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vu6i5aw2mal",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hpgnbk4irak"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#vu6i5aw2mal)",
    d: "m6.493.324 6.973-6.534"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nl83m71zxan",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4zcdhz8otam"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#nl83m71zxan)",
    d: "m63.175 48.424 6.974-6.534"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "41v9i6a2wap",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ucz5wenpaao"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#41v9i6a2wap)",
    d: "m-10.915 47.78 6.974-6.534"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s7xvwy6u7ar",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pysaw6d7haq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#s7xvwy6u7ar)",
    d: "m-23.771-15.911-5.998-7.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v123dwnssat",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#txest7c7uas"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#v123dwnssat)",
    d: "m32.912 32.188-5.999-7.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tbd6my6ioav",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#womu3f01mau"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#tbd6my6ioav)",
    d: "m-6.358 20.372-8.438-4.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vhkrncc98ax",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cnnwxmle1aw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#vhkrncc98ax)",
    d: "m51.988 65.738-8.438-4.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7cbnkjc9vaz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x16wynk34ay"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#7cbnkjc9vaz)",
    d: "m37.354 74.425-8.439-4.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ju725yqs9aB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qx7cl80g5aA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ju725yqs9aB)",
    d: "m.533-5.4-5.998-7.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fdawc3pbuaD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5y6kp1o62aC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#fdawc3pbuaD)",
    d: "m57.216 42.699-5.999-7.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7bpzvrra0aF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#omfm3u9dvaE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#7bpzvrra0aF)",
    d: "m10.246 39.526-8.438-4.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p6yweacuzaH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rj7tykfgsaG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#p6yweacuzaH)",
    d: "m66.929 87.626-8.439-4.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "16m2skg13aJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8sg17v57maI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#16m2skg13aJ)",
    d: "m-30.167 21.335 5.999 7.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aue2ifx2kaL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2de0n95ajaK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#aue2ifx2kaL)",
    d: "m-18.978-1.031-9.548.153"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jo2s3wukjaN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p6o9apjz0aM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#jo2s3wukjaN)",
    d: "m37.705 47.069-9.549.153"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "95dudvucqaP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cmre7nutfaO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#95dudvucqaP)",
    d: "m38.015 80.66-9.548.153"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kinb7pv0kaR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ddzozvyhtaQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#kinb7pv0kaR)",
    d: "m19.906 72.326-9.549.153"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hlssnak99aT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wmzdqhxkhaS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#hlssnak99aT)",
    d: "m10.806 19.511-1.673-9.415"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "70ctif4bkaV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dp0w24lw8aU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#70ctif4bkaV)",
    d: "m5.407-11.833-1.673-9.416"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jtd4qf8kpaX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aovq7pwiwaW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#jtd4qf8kpaX)",
    d: "m67.489 67.611-1.673-9.415"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hgz3rqyzwaZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#36xkd858uaY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#hgz3rqyzwaZ)",
    d: "m-30.485-10.53-9.548.152"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7df2j1j9mbb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ijlzujavgba"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#7df2j1j9mbb)",
    d: "m-6.238 6.141 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "duxud9x9bbd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vloc7rzozbc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#duxud9x9bbd)",
    d: "m50.444 54.241 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e3dy3ty4pbf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8taz5skupbe"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#e3dy3ty4pbf)",
    d: "m30.6 17.012 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0ti5nek86bh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zjql5rjw6bg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#0ti5nek86bh)",
    d: "m91.398 60.491.152 9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xoezfdag9bj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xh8qyewgqbi"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#xoezfdag9bj)",
    d: "m148.08 108.591.153 9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "asarsxuitbl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ptho07ppxbk"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#asarsxuitbl)",
    d: "m92.168 116.283 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ileb117s8bn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1c17suzmlbm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ileb117s8bn)",
    d: "m148.85 164.383 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m2orzn26fbp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rh9tibwcabo"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#m2orzn26fbp)",
    d: "m89.91 129.592-.152-9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o90zlkswjbr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ez605nafqbq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#o90zlkswjbr)",
    d: "m71.079 97.489.152 9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "px968dhjmbt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9bt1k88jfbs"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#px968dhjmbt)",
    d: "m127.761 145.589.152 9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gfpksfp8mbv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l2afi18vbbu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#gfpksfp8mbv)",
    d: "m124.554 89.247 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kpcmbtx92bx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rgv3odzajbw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#kpcmbtx92bx)",
    d: "m181.236 137.347 9.402-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rnlgbu0ctbz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#em3f91z5pby"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#rnlgbu0ctbz)",
    d: "m107.146 136.703 9.402-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wbnlw9hcubB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m6les01nobA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#wbnlw9hcubB)",
    d: "m80.973 93.291 4.617 8.372"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kuexs40bqbD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2kcs2wzxkbC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#kuexs40bqbD)",
    d: "m137.655 141.391 4.617 8.373"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qf1whwnm2bF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qaifzp37tbE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#qf1whwnm2bF)",
    d: "m122.328 99.776 9.087 2.942"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ntbapmhwybH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tdaz218hjbG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ntbapmhwybH)",
    d: "m179.01 147.876 9.088 2.941"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bqohlzdlybJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6oly68inqbI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#bqohlzdlybJ)",
    d: "m104.92 147.232 9.088 2.942"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3n8oc289ibL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6zxubtgvrbK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#3n8oc289ibL)",
    d: "m94.272 87.028.153 9.563"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m5mouv6i6bN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7hdlzahwcbM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#m5mouv6i6bN)",
    d: "m150.955 135.128.152 9.562"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1my7d8pa1bP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eo2j1nnhcbO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#1my7d8pa1bP)",
    d: "m118.726 114.045 9.401-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "as89195c1bR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z5c3wce9cbQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#as89195c1bR)",
    d: "m175.408 162.146 9.402-1.676"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1ydhto69pbT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j4axjw5qmbS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#1ydhto69pbT)",
    d: "m166.778 122.371 9.402-1.676"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icctyyvfabV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0iifytzenbU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#icctyyvfabV)",
    d: "m94.07 81.067-8.091-5.081"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kgmqx3tmbbX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb4cib511bW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#kgmqx3tmbbX)",
    d: "m150.752 129.166-8.091-5.081"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b1r6g6rjmbZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x6xkezpa8bY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#b1r6g6rjmbZ)",
    d: "m155.233 177.951-8.091-5.08"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ckmt52cjpcb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iz89xarmvca"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ckmt52cjpcb)",
    d: "M112.845 114.984 106.32 108"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "56t3rp2ldcd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z7ijzqnngcc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#56t3rp2ldcd)",
    d: "m162.948 117.025-6.525-6.984"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "67px2noktcf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6b9dw53gce"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#67px2noktcf)",
    d: "m169.527 163.083-6.524-6.983"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6tuwz0sysch",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w6c1vk8fccg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#6tuwz0sysch)",
    d: "m129.437 137.823-8.091-5.08"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v79cfowj8cj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#90uzz361uci"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#v79cfowj8cj)",
    d: "m111.963 87.399 6.974-6.535"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "frr3ed6hpcl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tq8qgrbkqck"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#frr3ed6hpcl)",
    d: "m168.646 135.498 6.973-6.534"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "anh1ksvnicn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0hqsgnqumcm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#anh1ksvnicn)",
    d: "m94.556 134.854 6.973-6.534"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mrrexhol8cp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xjdp5hctxco"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#mrrexhol8cp)",
    d: "m138.382 119.262-5.998-7.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "caspwoi31cr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qxb9uzl6hcq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#caspwoi31cr)",
    d: "m99.113 107.447-8.439-4.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "80lp8u63kct",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i3a62vhh4cs"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#80lp8u63kct)",
    d: "m157.459 152.813-8.439-4.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c2hj79indcv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2qn5bma8zcu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#c2hj79indcv)",
    d: "m142.824 161.499-8.438-4.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "878ezqpo2cx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ctyy3kie0cw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#878ezqpo2cx)",
    d: "m106.004 81.674-5.998-7.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lrzu7lgg0cz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qhaq1a0qhcy"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#lrzu7lgg0cz)",
    d: "m162.686 129.774-5.998-7.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "utsvb2fk1cB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#59vc53cfkcA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#utsvb2fk1cB)",
    d: "m115.717 126.601-8.439-4.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9b822oyv3cD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t32acz0djcC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#9b822oyv3cD)",
    d: "m62.802 101.725-8.439-4.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s6sh88a0pcF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xpn8apgd1cE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#s6sh88a0pcF)",
    d: "m172.399 174.7-8.439-4.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g3by5lo7vcH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3ya7trtytcG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#g3by5lo7vcH)",
    d: "m75.304 108.409 5.998 7.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lav6gt11acJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftpc6cqencI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#lav6gt11acJ)",
    d: "m86.493 86.043-9.549.153"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dp5aibo6gcL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q30ag5e4qcK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#dp5aibo6gcL)",
    d: "m143.175 134.143-9.548.153"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0gfm3coqacN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#84sejyhvrcM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#0gfm3coqacN)",
    d: "m143.485 167.734-9.548.153"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gn066nhq8cP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gn6lawix5cO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#gn066nhq8cP)",
    d: "m116.277 106.585-1.673-9.415"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u26t6cbx0cR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6p747arv0cQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#u26t6cbx0cR)",
    d: "m110.877 75.241-1.672-9.416"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2i3ke8m28cT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qorf10wz3cS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#2i3ke8m28cT)",
    d: "m172.959 154.685-1.672-9.415"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e4aya0eiqcV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#32hy2axrycU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#e4aya0eiqcV)",
    d: "m131.668 124.643-9.548.153"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "91eb7dmqbcX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x53yq1g4vcW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#91eb7dmqbcX)",
    d: "m99.232 93.215 9.402-1.675"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.58 113.015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "furbf7p78cZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kxn3gvdrlcY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#furbf7p78cZ)",
    d: "m155.915 141.315 9.401-1.675"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.82 196c-1.745-.994-3.076-1.564-3.996-1.71-1.118-.178-2.783-.25-4.988-.218l-5.544 35.214c3.615.862 4.948-.194 5.498-2.127.551-1.934.646-2.22 1.044-3.492l9.83-15.211a.634.634 0 0 0-.183-.874l-.015-.01-2.373-1.456c-.558-1.96-.748-3.51-.568-4.653.145-.926.72-2.146 1.72-3.663a1.266 1.266 0 0 0-.35-1.752l-.076-.047z",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.533 194.718-1.008 15.085s88.082 16.733 108.873 12.043c0 0 32.928-10.019 74.007-107.334l-48.402-10.396-41.379 88.345a4.89 4.89 0 0 1-4.174 2.344l-87.917-.087z",
    fill: "#9C3A83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kzbwajfnudb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w026elukyda"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#kzbwajfnudb)",
    d: "m210.095 51.801-8.73-3.737"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kinddrlvfdd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ejfeq1nijdc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#kinddrlvfdd)",
    d: "m143.844 84.615-8.73-3.737"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i7twwo2ovdf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d68yr93thde"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#i7twwo2ovdf)",
    d: "m159.208 29.886-2.237 9.356"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3se8nwzr8dh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xqslqn9x7dg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#3se8nwzr8dh)",
    d: "m92.957 62.7-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ll03ia1podj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7uihid7zxdi"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ll03ia1podj)",
    d: "m148.044 22.405 8.73 3.737"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rcivhadwodl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ixgiqm167dk"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#rcivhadwodl)",
    d: "m184.671 18.041-8.73-3.737"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "iwwholyesdn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#plc4xl7b2dm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#iwwholyesdn)",
    d: "m118.42 50.856-8.73-3.738"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ej508nvladp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#59n07vh0ado"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ej508nvladp)",
    d: "m56.629 70.517-8.73-3.737"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ka83dmjqodr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#133y0sgx6dq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ka83dmjqodr)",
    d: "m170.779 70.744-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fiz5hpriodt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w44omzt2wds"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#fiz5hpriodt)",
    d: "m104.528 103.558-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1wsbp21ygdv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v82wyt4twdu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#1wsbp21ygdv)",
    d: "m134.711 35.431-2.237 9.356"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fqjhsvxpodx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8sqe5vakqdw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#fqjhsvxpodx)",
    d: "m184.523 28.877-9.434.866"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ryboinmvmdz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2dyrwrhg3dy"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ryboinmvmdz)",
    d: "m118.272 61.691-9.434.866"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "talisab3adB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#izamvbpgwdA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#talisab3adB)",
    d: "m162.124 64.419-6.297 7.195"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u1xcg6hnydD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t93b8mnj0dC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#u1xcg6hnydD)",
    d: "m95.872 97.233-6.296 7.195"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gg741jn1adF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oaaopso2jdE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#gg741jn1adF)",
    d: "m126.055 29.105-6.296 7.196"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4fmdnnqfudH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r1rolrj38dG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#4fmdnnqfudH)",
    d: "m184.889 43.693-8.73-3.738"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xbvxqpxqodJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uhygbjjuudI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#xbvxqpxqodJ)",
    d: "m118.638 76.507-8.73-3.738"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "47zj5qc8bdL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1areedvkfdK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#47zj5qc8bdL)",
    d: "m150.626 55.308-2.237 9.356"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j08lfsfazdN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t4djerchzdM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#j08lfsfazdN)",
    d: "m84.375 88.122-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lvshka7m2dP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8meotnw84dO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#lvshka7m2dP)",
    d: "m123.881 96.286-2.236 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "06fajuxz9dR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ccvshipusdQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#06fajuxz9dR)",
    d: "m190.374 45.923 7.839-5.408"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vkwpbk57mdT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pyjefexixdS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#vkwpbk57mdT)",
    d: "m124.123 78.737 7.839-5.407"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o7domja6rdV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sj01ievz2dU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#o7domja6rdV)",
    d: "m78.105 63.089 7.839-5.408"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u9t9leusldX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kbs89fomwdW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#u9t9leusldX)",
    d: "m152.125 49.498 8.938-3.189"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lnbbnb8kldZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t45f7v12vdY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#lnbbnb8kldZ)",
    d: "m85.874 82.312 8.938-3.189"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mjbshbviieb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jygrz1gbnea"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#mjbshbviieb)",
    d: "m191.041 22.738 7.839-5.408"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "12bup7izwed",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z5pqp7csgec"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#12bup7izwed)",
    d: "m124.79 55.552 7.839-5.408"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rjpsdgt1vef",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#066ett8yaee"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#rjpsdgt1vef)",
    d: "m177.486 59.872 3.136 9.087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rp6rma6a2eh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0w8anyq73eg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#rp6rma6a2eh)",
    d: "m111.235 92.686 3.137 9.088"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zsh7l31t7ej",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v3s6ud036ei"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#zsh7l31t7ej)",
    d: "m141.418 24.559 3.137 9.087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dro32tqdwel",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5hf8s7jk3ek"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#dro32tqdwel)",
    d: "m204.295 38.522 9.143-2.518"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f349bft63en",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#61z6b2uirem"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#f349bft63en)",
    d: "m138.044 71.336 9.142-2.518"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "plaay10ydep",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qtevkk77qeo"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#plaay10ydep)",
    d: "m100.007 75.339 7.43-5.974"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6clorutcder",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i3iz9jog4eq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#6clorutcder)",
    d: "m97.978 58.308 7.43-5.974"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "z49xukie9et",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#szsrffak4es"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#z49xukie9et)",
    d: "m185.056 56.693 9.142-2.518"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cjy19w9hwev",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w5debtwkheu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#cjy19w9hwev)",
    d: "m118.805 89.507 9.142-2.518"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "omnrq02i3ex",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mto3okapzew"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#omnrq02i3ex)",
    d: "m140.446 47.439 7.43-5.974"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hf0pc3vr0ez",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ti72tcrgsey"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#hf0pc3vr0ez)",
    d: "m74.195 80.253 7.43-5.974"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8ysgat0j4eB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2q3rqwk69eA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#8ysgat0j4eB)",
    d: "m173.083 17.513-9.143 2.518"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "koprv780feD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tvmko32aheC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#koprv780feD)",
    d: "m188.889 36.911 3.677-8.875"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rud72bmr4eF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7dwpryxkpeE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#rud72bmr4eF)",
    d: "m122.638 69.725 3.676-8.875"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "csxzv596seH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x7oi6lm7veG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#csxzv596seH)",
    d: "m92.061 56.389 3.676-8.875"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "88hj3rh71eJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z8ktz7r0ieI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#88hj3rh71eJ)",
    d: "m106.851 43.054 3.676-8.876"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "06kyjw8rzeL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lyf9uvg63eK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#06kyjw8rzeL)",
    d: "m188.941 63.8 9.203 2.274"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hi6l9d671eN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stkzr5ztbeM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#hi6l9d671eN)",
    d: "m92.117 88.886 9.203 2.274"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9zd58b2qkeP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kun8gv4xweO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#9zd58b2qkeP)",
    d: "m202.098 30.142 3.677-8.875"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tgrncalgheR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gxfwddmskeQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#tgrncalgheR)",
    d: "m135.847 62.956 3.677-8.875"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dgykyth3aeT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vmo936yhxeS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#dgykyth3aeT)",
    d: "m177.298 45.762-2.237 9.356"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xhusb7qi5eV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tz54hunyfeU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#xhusb7qi5eV)",
    d: "m111.047 78.576-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l17jy9p4ueX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xhjcj98dreW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#l17jy9p4ueX)",
    d: "m152.725 75.356-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g058vq86eeZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gbfc2i3q0eY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#g058vq86eeZ)",
    d: "m89.019 113.843-8.73-3.737"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yg7a28mxifb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lhj60m170fa"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#yg7a28mxifb)",
    d: "m22.768 146.658-8.73-3.738"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cluvuqmwmfd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ic8vvyiuufc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#cluvuqmwmfd)",
    d: "m38.132 91.928-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i8jnpyvxuff",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#znq3vyb62fe"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#i8jnpyvxuff)",
    d: "m-28.119 124.742-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t0d0tqic6fh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1qv0rvpmpfg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#t0d0tqic6fh)",
    d: "m26.969 84.447 8.73 3.737"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5qi5g3ku2fj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#47y4h86qffi"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#5qi5g3ku2fj)",
    d: "m63.596 80.083-8.73-3.737"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mny168hdtfl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vi3pbgczhfk"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#mny168hdtfl)",
    d: "m-2.655 112.898-8.731-3.738"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o0zba4n8vfn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lmsvytglvfm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#o0zba4n8vfn)",
    d: "m49.704 132.786-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ta32kqdojfp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j6ozycfa6fo"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ta32kqdojfp)",
    d: "m-16.547 165.6-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ylzoq4poafr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#84tp3uboifq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ylzoq4poafr)",
    d: "m13.635 97.473-2.237 9.356"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ui0xcgix4ft",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jd2kdtlgyfs"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ui0xcgix4ft)",
    d: "m-2.803 123.733-9.435.866"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1h587de79fv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6ahu6gvpfu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#1h587de79fv)",
    d: "m41.048 126.461-6.296 7.195"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mbqkr2t7vfx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2jsluad4cfw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#mbqkr2t7vfx)",
    d: "m-25.203 159.275-6.297 7.195"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "is7mytgl8fz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qzy0yjx7mfy"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#is7mytgl8fz)",
    d: "m4.98 91.148-6.297 7.195"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c99uhveo9fB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jwgg0bkiqfA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#c99uhveo9fB)",
    d: "m63.814 105.735-8.73-3.737"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dlwi5u6jnfD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hu6r8d961fC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#dlwi5u6jnfD)",
    d: "m-2.438 138.549-8.73-3.737"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fveagq2ndfF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8yu14ekzpfE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#fveagq2ndfF)",
    d: "m29.55 117.35-2.236 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9lnm48dcafH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hd1sozn4qfG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#9lnm48dcafH)",
    d: "m-36.701 150.164-2.236 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xl3m06xl6fJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k7eblghl0fI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#xl3m06xl6fJ)",
    d: "m2.806 158.328-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "txckxwfbjfL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iqb3fm7bhfK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#txckxwfbjfL)",
    d: "m69.298 107.965 7.839-5.407"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vbtvxdnchfN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ou3xir22cfM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#vbtvxdnchfN)",
    d: "m3.048 140.78 7.839-5.408"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6h7gj75v5fP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sxu209nxwfO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#6h7gj75v5fP)",
    d: "m-42.971 125.131 7.839-5.408"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ohxxzu6mffR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o73zl89wmfQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ohxxzu6mffR)",
    d: "m31.05 111.54 8.938-3.189"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "90x3zeq5afT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uyxs3zakvfS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#90x3zeq5afT)",
    d: "m9.183 156.96 8.938-3.189"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u4h5j0corfV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#05jv8khjlfU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#u4h5j0corfV)",
    d: "m-35.201 144.355 8.938-3.189"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "360mwi8swfX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yan2xso7zfW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#360mwi8swfX)",
    d: "m3.715 117.594 7.839-5.408"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vukc1sxssfZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#esipc0b9cfY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#vukc1sxssfZ)",
    d: "m56.41 121.914 3.137 9.087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "idb0eajergb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uya51mt2lga"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#idb0eajergb)",
    d: "m-9.84 154.728 3.136 9.087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lpuv64qbrgd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kj4bydtsrgc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#lpuv64qbrgd)",
    d: "m20.342 86.601 3.137 9.087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d670t7dgvgf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kkmfwru4cge"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#d670t7dgvgf)",
    d: "m16.969 133.378 9.142-2.518"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w18nivzy4gh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qttsgrtlsgg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#w18nivzy4gh)",
    d: "m43.368 101.923 7.43-5.974"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6lzm2hd4ogj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8dvny28nwgi"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#6lzm2hd4ogj)",
    d: "m-21.069 137.381 7.43-5.974"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n6oa2unhxgl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ioza8613fgk"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#n6oa2unhxgl)",
    d: "m-23.097 120.35 7.43-5.974"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nl5v3aawhgn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#85lvlezf7gm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#nl5v3aawhgn)",
    d: "m-2.271 151.549 9.143-2.518"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3iizuq4mbgp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8a52xhb09go"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#3iizuq4mbgp)",
    d: "m19.371 109.481 7.43-5.974"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "412fhuyk0gr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8yhp7v2o9gq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#412fhuyk0gr)",
    d: "m63.062 70.725 7.43-5.974"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4oupg1de1gt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3mamav0i7gs"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#4oupg1de1gt)",
    d: "m-46.881 142.295 7.431-5.974"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cuyc1qj5igv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ubx2vj2chgu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#cuyc1qj5igv)",
    d: "m52.007 79.555-9.142 2.518"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fnxvclsdtgx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6qt81vuzggw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#fnxvclsdtgx)",
    d: "m67.813 98.953 3.677-8.875"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ru81sdge1gz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nexwqcj0agy"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ru81sdge1gz)",
    d: "m1.563 131.767 3.676-8.875"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fzlvwvu1cgB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2sean35gxgA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#fzlvwvu1cgB)",
    d: "m-29.015 118.431 3.677-8.875"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "29s5pxpqtgD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ifxxvoj15gC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#29s5pxpqtgD)",
    d: "m37.292 118.115 9.204 2.274"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rk9o4tq0egF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d0tiuleb5gE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#rk9o4tq0egF)",
    d: "m67.865 125.842 9.204 2.274"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "om2g1m97rgH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6jbab29wggG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#om2g1m97rgH)",
    d: "m-28.959 150.929 9.204 2.274"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8x3mti6plgJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uk88wkuycgI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#8x3mti6plgJ)",
    d: "m14.772 124.999 3.676-8.876"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m5edpjylsgL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0xy3eaa5qgK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#m5edpjylsgL)",
    d: "m56.222 107.804-2.236 9.356"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zbxb61keigN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o83tfbf42gM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#zbxb61keigN)",
    d: "m-10.029 140.618-2.237 9.357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.759 104.676)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xttatq8sxgP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lvs630z7cgO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#xttatq8sxgP)",
    d: "m31.65 137.399-2.237 9.356"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M389.976 285.786c.078 1.826.285 3.13.617 3.913.405.95 1.156 2.272 2.251 3.962 1.107-.467 11.057-4.677 29.85-12.63-1.134-2.711-2.069-3.87-3.828-3.367a125.88 125.88 0 0 1-3.68 1.006l-16.498-.296a.574.574 0 0 0-.585.563v.015l.027 2.535c-1.241 1.374-2.345 2.265-3.313 2.674-.786.334-2.005.476-3.66.43a1.146 1.146 0 0 0-1.181 1.113v.082z",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.785 88.17 8.201 5.062c-18.263 16.254-27.99 24.82-29.18 25.698-2.678 1.978-2.887 7.354-3.247 10.091-3.993-.516-.477-5.49-5.557-6.072-4.638-.53-9.247.826-11.841-4.287-.32-.628-.15-2.16 1.777-2.257 4.803-.246 12.162-1.314 13.638-2.243 2.014-1.268 10.75-9.932 26.209-25.992M287.937 31.066s-4.847 3.456-5.84 12.362c-1.313.017-2.353-4.678-2.353-4.678l3.019-9.35 3.071-2.74 2.103 4.406z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(215.067)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zng4damihgR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lsvb958ywgQ"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.662 15.953s4.692-4.639 13.308-2.484c0 0 3.948-4.438-2.175-8.199-6.123-3.762-10.65-4.89-18.52-.537-6.434 3.558-10.488 2.87-15.441.63-4.954-2.238-7.52-4.875-11.616-3.909-4.097.967-6.65 4.823-11.074 3.154C20.721 2.94 18.862-1.769 11.1.702 3.338 3.174-6.256 15.425 5.495 27.784c11.75 12.359 29.329 9.564 39.997 7.415s20.673-4.624 21.976-8.175c1.303-3.553-2.031-7.535 3.194-11.071",
    fill: "#E10A0A",
    mask: "url(#zng4damihgR)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.501 58.86c12.878-7.299 28.485-9.787 45.518-13.339l-10.993 6.56-27.176 9.032s-7.317-.337-7.349-2.252",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.617 17.262c0 1.827-1.056 3.308-2.359 3.308-1.302 0-2.358-1.48-2.358-3.308 0-1.826 1.056-3.306 2.358-3.306 1.303 0 2.36 1.48 2.36 3.306M299.005 22.663l.598 6.144a.597.597 0 0 1-.785.622l-3.416-1.158 3.603-5.608z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.375 94.92 3.692.417s-32.292 33.922-39.758 31.679c-7.465-2.244-38.259-37.826-35.94-45.602 2.318-7.775 34.454-24.316 34.454-24.316l37.552 37.822z",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.609 115.866a4.016 4.016 0 0 1 .208-3.828l1.408-2.29a4.05 4.05 0 0 1 4.473-1.794 68.284 68.284 0 0 0 2.195-3.441c5.8-9.75 6.952-21.09 11.049-31.063-17.958 6.154-37.813 21.157-59.568 45.013l-13.957-10.83a307.827 307.827 0 0 1 4.483-5.875c-1.413-1.748-1.674-7.314.171-7.502a19.846 19.846 0 0 1 5.708.241c31.648-37.777 67.875-60.265 108.686-67.468l4.515 1.773 4.62 3.512c-17.377 35.796-23.887 106.213-67.513 165.912-11.919-1.862-20.812-11.422-34.198-18.757-16.93-9.278-23.573-30.083-45.856-29.976 12.23-27.2 52.049-8.457 73.576-33.627",
    fill: "#AAE2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.604 102.1a3.596 3.596 0 0 0-4.055 2.2 3.576 3.576 0 0 0 2.025 4.644 3.597 3.597 0 0 0 4.66-2.02 3.58 3.58 0 0 0-2.63-4.824M235.725 121.675a3.597 3.597 0 0 0-4.055 2.199 3.578 3.578 0 0 0 2.63 4.824 3.598 3.598 0 0 0 4.057-2.198 3.578 3.578 0 0 0-2.027-4.646 3.738 3.738 0 0 0-.605-.179M228.166 142.398a3.595 3.595 0 0 0-4.055 2.2 3.576 3.576 0 0 0 2.025 4.644 3.6 3.6 0 0 0 4.66-2.02 3.578 3.578 0 0 0-2.026-4.644c-.2-.08-.401-.139-.604-.18",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.559 27.029s-4.326 26.207-18.803 42.995C228.28 85.653 204.138 94.37 204.138 94.37l4.139 3.638s18.72-3.355 40.062-28.56c15.686-18.523 18.098-42.53 18.098-42.53l-5.878.11z",
    fill: "#007371"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m402.313 288.38 5.74 4.193 16.53-7.249-2.734-5.122-19.536 8.178zm-.96 1.2v.001l1.07-.46h-.001l-1.069.459zm-8.026 3.45 3.331 5.08 7.854-3.488-3.159-5.04-8.026 3.448z",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.279 23.125-1.466-.821a2.44 2.44 0 0 1-.937-3.352l.959-1.663a.768.768 0 0 1 1.04-.283l2.97 1.664a.088.088 0 0 1 .034.12l-2.479 4.302a.09.09 0 0 1-.121.033",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeWidth: 0.903,
    strokeLinecap: "round",
    d: "m297.22 17.798-10.678-2.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007371",
    d: "m66.741 196.664-5.251 33.815-5.428-1.373 2.513-19.016 6.58-3.21.185-1.202-6.038.038 1.275-8.881z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M366.4 126.125s4.737 8.247-5.267 8.247l5.267-8.247z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.373 105.908c-.881-3.943-.509-7.3.04-11.255.412-2.976.586-7.19-3.157-7.435-3.125-.205-5.084 2.974-5.185 6.146-.315 9.865 8.302 12.544 8.302 12.544",
    fill: "#FEC988"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M494.774 272.304h26.696V299h-26.696z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedHelpIllustrationRunningHero);
export default __webpack_public_path__ + "static/media/need-help-illustration-running-hero.ebab7d9a40a88bffe7c5a390a5ff50f3.svg";
export { ForwardRef as ReactComponent };